__turbopack_context__.v({
  "card": "-9mA-W_card",
  "cardLink": "-9mA-W_cardLink",
  "default": "-9mA-W_default",
  "description": "-9mA-W_description",
  "footer": "-9mA-W_footer",
  "footerEnd": "-9mA-W_footerEnd",
  "footerStart": "-9mA-W_footerStart",
  "header": "-9mA-W_header",
  "headerEnd": "-9mA-W_headerEnd",
  "headerStart": "-9mA-W_headerStart",
  "linked": "-9mA-W_linked",
  "muted": "-9mA-W_muted",
  "paddingLg": "-9mA-W_paddingLg",
  "paddingNone": "-9mA-W_paddingNone",
  "paddingSm": "-9mA-W_paddingSm",
  "title": "-9mA-W_title",
  "transparent": "-9mA-W_transparent",
});
